const normalizeDomain = (domain: string): string => domain.replace('@', '').toLowerCase();

export default normalizeDomain;
